import { createContext } from "react"

export const CurrentReadingIndexContext = createContext(0)
